module.exports = __webpack_public_path__ + "img/Certificate.3574dfb0.jpg";